export const MAX_INTERVIEW_REVIEW_DENIAL_LIMIT = 3;

export enum InterviewChallengeRequestStatusFilter {
  UNREVIEWED = 'unreviewed',
  NOT_SUBMITTED = 'not_submitted',
  ALL = 'all',
}

export enum TechnicalChallengeStatus {
  OPENED = 'OPENED',
  REVIEWED = 'REVIEWED',
  CLOSED = 'CLOSED',
}

export const TechnicalChallengeStatusLabel: { [status in TechnicalChallengeStatus]: string } = {
  [TechnicalChallengeStatus.OPENED]: 'Opened',
  [TechnicalChallengeStatus.REVIEWED]: 'Reviewed',
  [TechnicalChallengeStatus.CLOSED]: 'Closed',
};
